import { REFRESH_AT_REQUEST, CHECK_AUTH } from '../actionTypes';

export const refreshToken = () => ({ type: REFRESH_AT_REQUEST });

export function checkAuth(payload) {
    return { payload, type: CHECK_AUTH };
}
